export const R1 = '0px';
export const R2 = '2px';
export const R3 = '4px';
export const R4 = '6px';
export const R5 = '8px';
export const R6 = '10px';
